import { render, staticRenderFns } from "./UiControlGroup.vue?vue&type=template&id=68b91ce5"
import script from "./UiControlGroup.vue?vue&type=script&lang=js"
export * from "./UiControlGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports